import { render, staticRenderFns } from "./StockSyncOrder.vue?vue&type=template&id=c203601c&scoped=true&"
import script from "./StockSyncOrder.vue?vue&type=script&lang=js&"
export * from "./StockSyncOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c203601c",
  null
  
)

export default component.exports